<template>
  <div class="mk-object-selection">
    <div class="mk-object-selection__container">
      <button
        class="mk-object-selection__container__close"
        @click="closeCallback"
      >
        X
      </button>
      <span class="mk-object-selection__title">
        {{objects.standard ? objects.standard[0].type : 'Clamps'}}
      </span>
      <span class="mk-object-selection__label">
        Standard
      </span>
      <div class="mk-object-selection__section" v-if="objects.standard">
        <div
          v-for="(object, index) in objects.standard"
          :key="`objects-1-${index}`"
          class="mk-object-selection__section__element"
        >
          <ObjectButton :object="object" :closeCallback="close" />
        </div>
      </div>
      <div class="mk-object-selection__section" v-if="objects.clamps && clampApproval">
        <div
          v-for="(object, index) in objects.clamps"
          :key="`clamps-1-${index}`"
        >
          <ObjectButton
            :object="{
              ...object,
              ...(clampApproval.first ? clampApproval.first : clampApproval.second),
            }"
            :closeCallback="close"
          />
        </div>
      </div>
      <span
        v-if="objects.extension"
        class="mk-object-selection__label"
      >
        Extension
      </span>
      <div
        v-if="objects.extension"
        class="mk-object-selection__section"
      >
        <div
          class="mk-object-selection__section__element"
          v-for="(object, index) in objects.extension"
          :key="`objects-2-${index}`"
        >
          <ObjectButton :object="object" :closeCallback="close"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Object Selection Popup
 * @author David <david.prenninger@gmx.de>
 *
 * This Popup presents all options for the user to choose from.
 * Its dynamic and can be populated with any Product type.
 */
import ObjectButton from '@/components/ObjectButton.vue';
import { serializeSectionObject } from '../helpers/url';

export default {
  components: {
    ObjectButton,
  },
  props: {
    closeCallback: Function,
    objects: Object,
    updateIndex: null || Number,
    clampApproval: undefined || Object,
  },
  computed: {
    objectSections() {
      return this.$store.getters.objectSections;
    },
    standApproval() {
      return this.$store.getters.standApproval;
    },
    productsStands() {
      return this.$store.getters.stands;
    },
    inlineConnector() {
      return this.$store.getters.inLineConnector;
    },
    endConnector() {
      return this.$store.getters.endConnector;
    },
  },
  methods: {
    close(object) {
      // If object is a clamp set clamp Position
      let clampPos;
      if (this.clampApproval && this.clampApproval.first) {
        clampPos = 'clamp1';
      } else if (this.clampApproval && this.clampApproval.second) {
        clampPos = 'clamp2';
      }

      // Set objectSection key
      const updateData = {};
      if (clampPos && object.type === 'clamp') {
        updateData[clampPos] = object;
      } else if (object.type === 'standard-glass' || object.type === 'extension-glass') {
        updateData.glass = object;
      } else {
        updateData[object.type] = object;
      }

      // If an Update Index exists
      if (this.updateIndex !== null) {
        // If a Stand is added change connector to Inline
        console.log(this.updateIndex !== this.objectSections.length - 1);
        if (
          this.updateIndex !== 0
          && object.type === 'stand'
          && !this.objectSections[this.updateIndex].connector.isInline
          && (this.updateIndex !== this.objectSections.length - 1
            || !this.objectSections[this.updateIndex].connector.angle > 0)
        ) {
          updateData.connector = this.inlineConnector;
        }
        this.$store.dispatch('setSectionObject', { index: this.updateIndex, data: updateData });
      } else {
        // Add first Stand if this is the first object to be added.
        if (this.objectSections.length === 0) {
          const standList = [...this.productsStands];
          standList.sort((a, b) => b.length - a.length);
          const selectedStand = standList.find(
            (stand) => this.standApproval[0].stand.distanceBack >= stand.length / 2
            && this.standApproval[0].stand.distanceFront >= stand.length / 2,
          );
          const startConnector = {
            ...this.endConnector,
            angle: 0,
            width: 0.1,
            length: 0.074,
            size: 11,
          };
          this.$store.dispatch('setSectionObject', { data: { stand: selectedStand, connector: startConnector } });
        }
        if (
          (object.type === 'standard-glass' || object.type === 'extension-glass')
          && this.objectSections.length - 1 > 0
          && this.objectSections[this.objectSections.length - 1].connector !== this.inlineConnector
          && this.objectSections[this.objectSections.length - 1].stand
        ) {
          this.$store.dispatch('setSectionObject', {
            index: this.objectSections.length - 1,
            data: {
              connector: this.inlineConnector,
            },
          });
        }
        this.$store.dispatch('setSectionObject', { data: updateData });
      }
      serializeSectionObject(this.objectSections, this);
      this.closeCallback();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-object-selection {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($c_primary, 0.1);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;

  &__container {
    position: relative;
    display: flex;
    flex-direction: column;
    // height: 50%;
    width: 80%;
    padding: 20px;
    background-color: $c_white;
    box-shadow: $bs_md;
    overflow: auto;
    max-height: 90%;

    &__close {
      background-color: $c_white;
      box-shadow: $bs_md;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 10px;
      right: 10px;
      border: none;
    }
  }

  &__title {
    font-size: 20px;
    margin: 10px;
    text-transform: capitalize;
  }

  &__label {
    text-align: left;
    color: $c_primary_lighter;
  }

  &__section {
    margin: 10px 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));

    &__element {
      width: fit-content;
      margin: 0 auto;
    }
  }
}
</style>
